import type { Flag } from '../../../types';
import { useFlag } from '../use-flag';
import css from './switch.module.scss';

interface Props {
    flag: Flag;
}
export function Switch({ flag }: Props) {
    const { value, onChange } = useFlag(flag);

    return (
        <label className={css.toggle}>
            <input
                id={flag.id}
                checked={!!value}
                className={css.input}
                onChange={e => onChange(e.target.checked)}
                type="checkbox"
            />
            <span className={css.slider} />
        </label>
    );
}
